export const CURRENT_VERSION = 1;
export const SERVER_URL = "https://api.etebase.com";
